import React from 'react';

import { BulletListItemWrapper, BulletListItemContent, Title, Description } from './styled';

interface IBulletListItem {
	title: string;
	content: string | React.ReactNode;
	BulletIcon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}

const BulletListItem = ({ title, content, BulletIcon }: IBulletListItem): JSX.Element => (
	<BulletListItemWrapper>
		<BulletIcon />
		<BulletListItemContent>
			<Title>{title}</Title>
			<Description>{content}</Description>
		</BulletListItemContent>
	</BulletListItemWrapper>
);

export default BulletListItem;
